import styled, { css, SimpleInterpolation } from 'styled-components';
import { COLOURS, media, SHADOWS } from '@belong/themes';
import { MaybeStyledCSS } from '@belong/types';
import { Stack } from '../../ui';
import { ControlledHeightContainer } from './ControlledHeightContainer';

export const Outerwrapper = styled.div<{ withTopPadding: boolean }>`
  ${media('sm')`
    max-width: 38rem;
  `}
  width: 100%;
  height: 100%;

  ${({ withTopPadding }): MaybeStyledCSS =>
    withTopPadding &&
    css`
      padding-top: 2.8rem;
      ${media('md')` padding-top: 4rem;`}
    `}
`;

export const Wrapper = styled.div<{ withDifferentiator: boolean }>`
  position: relative;
  border-radius: 8px;
  box-shadow: ${SHADOWS.AMBIENT_LIGHT};
  transition: box-shadow 0.3s ease-in;
  background-color: ${COLOURS.WHITE};
  display: flex;
  flex-direction: column;
  justify-content: stretch;

  ${({ withDifferentiator }): MaybeStyledCSS =>
    !withDifferentiator &&
    css`
      height: 100%;
    `}

  &:hover {
    box-shadow: ${SHADOWS.HOVER};
    .cta-button {
      border-color: ${COLOURS.BELONG_BLUE};
      background-color: ${COLOURS.BELONG_BLUE};
      color: ${COLOURS.BLACK};
    }
  }
`;

export const FullHeightStack = styled(Stack)<{ fillLastItem?: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  ${({ fillLastItem }): SimpleInterpolation =>
    fillLastItem
      ? css`
          > div:last-child {
            margin-top: auto;
            height: auto;
          }
        `
      : css`
          > div:last-child {
            height: 100%;
          }
        `}
`;

export const FlexChildGrow = styled.div`
  flex-grow: 1;
`;

export const PlanTitle = styled.div<{ isPlanSelected?: boolean }>`
  position: relative;
  min-height: 3.6rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0.8rem;
  padding-left: 0.8rem;
  ${media('md')`
    min-height: 4.8rem;
 `}
  background-color: ${(props): string => (props.isPlanSelected ? COLOURS.LIGHT_GREEN : COLOURS.GREY_100)};
`;
export const PlanBody = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  padding: 1.2rem;
`;

export const AccordionsWrapper = styled.div`
  width: 100%;
`;

export const Skeleton = styled.div<{ skeletonHeight: string }>`
  position: relative;
  border-radius: 8px;
  width: 100%;
  height: ${({ skeletonHeight }): string => skeletonHeight};
  background-color: ${COLOURS.GREY_100};
`;

export const ActivityLevelContainer = styled(ControlledHeightContainer)`
  display: flex;
  gap: 0.8rem;
  ${media('lg')`
    padding: 0 2.4rem;
  `}
  font-size: 1.5rem;
  width: fit-content;
  svg {
    color: ${COLOURS.GREY_700};
  }
  dl {
    dt {
      color: ${COLOURS.GREY_700};
      font-size: 1.7rem;
      font-weight: 600;
    }
    dd {
      margin-left: 0;
      color: ${COLOURS.GREY_600};
      line-height: 2rem;
    }
  }
`;
